const SummaryPage = ({ section }) => {
  const data = {
    제목: section?.question.data.title,
    주제: section?.question.data.topic,
    목적: section?.question.data.purpose,
    "세 줄 요약": section?.question.data.three_sentence_summary,
  };

  return (
    <div
      style={{
        width: "70%",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          marginBottom: "50px",
        }}
      >
        지문 핵심 정리
      </div>
      <div
        style={{
          display: "table",
          borderCollapse: "collapse",
          backgroundColor: "#FFF",
          border: "1px solid #ddd",
          fontFamily: '"Noto Sans KR", sans-serif',
        }}
      >
        {Object.entries(data).map(([key, value], index) => (
          <div
            key={index}
            style={{
              display: "table-row",
              borderBottom: "1px solid #ddd",
              fontSize: "18px",
            }}
          >
            <div
              style={{
                display: "table-cell",
                padding: "15px",
                backgroundColor: "rgba(45, 240, 52, 0.05)",
                border: "1px solid #2DF034",
                width: "80px", // 좌측 칸 너비
                textAlign: "center", // 텍스트 수평 정렬
                verticalAlign: "middle", // 텍스트 수직 정렬
              }}
            >
              {key}
            </div>
            {/* 우측 값 */}
            <div
              style={{
                display: "table-cell",
                padding: "15px",
              }}
            >
              {key === "세 줄 요약"
                ? value.split("\n").map((line, index) => (
                    <div
                      style={{
                        marginBottom: "10px",
                      }}
                      key={index}
                    >
                      {line}
                    </div>
                  ))
                : value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummaryPage;
